import React, { useState } from 'react';
import styled from 'styled-components';

const TopMenuBarWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 5px 0;
`;

const MenuButton = styled.button`
  width: 88px;
  height: 22px;
  margin: 5px;
  padding: 3px;
  border: 1px solid yellow;
  background-color: ${({ active }) => (active ? 'yellow' : 'transparent')};
  color: ${({ active }) => (active ? 'navy' : 'yellow')};
  font-family: 'Times New Roman';
  font-size: 12px;
  font-weight: bold;
  font-style: italic;
  cursor: pointer;

  &:active {
    transform: scale(0.95);
  }
`;

const TopMenuBar = ({ onMenuButtonClick }) => {
  const [activeButton, setActiveButton] = useState('');

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
    onMenuButtonClick(buttonName);
  };

  return (
    <TopMenuBarWrapper>
      <MenuButton
        active={activeButton === 'PC'}
        onClick={() => handleButtonClick('PC')}
      >
        PC
      </MenuButton>
      <MenuButton
        active={activeButton === 'PI'}
        onClick={() => handleButtonClick('PI')}
      >
        PI
      </MenuButton>
      <MenuButton
        active={activeButton === 'PTC'}
        onClick={() => handleButtonClick('PTC')}
      >
        PTC
      </MenuButton>
      <MenuButton
        active={activeButton === 'TRADING'}
        onClick={() => handleButtonClick('TRADING')}
      >
        TRADING
      </MenuButton>
    </TopMenuBarWrapper>
  );
};

export default TopMenuBar;

